<template>
  <div>
    {{news.textParams[0]}} {{$t('news.template.party.updatedWebsiteConsolidated.p1')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[1]}}</a>
    {{$t('news.template.party.updatedWebsiteConsolidated.p2')}}
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>
